var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeukemia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63 12.23C8.37 12.23 7.35001 13.25 7.35001 14.51C7.35001 15.77 8.37 16.79 9.63 16.79M17.48 6.72C17.22 6.72 17 6.51 17 6.24M17 6.25C17 5.99 17.21 5.77 17.48 5.77M15.26 14.5C15.26 17.6094 12.7394 20.13 9.63 20.13C6.52064 20.13 4 17.6094 4 14.5C4 11.3906 6.52064 8.87 9.63 8.87C12.7394 8.87 15.26 11.3906 15.26 14.5ZM20.73 6.25C20.73 8.04493 19.2749 9.5 17.48 9.5C15.6851 9.5 14.23 8.04493 14.23 6.25C14.23 4.45507 15.6851 3 17.48 3C19.2749 3 20.73 4.45507 20.73 6.25Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeukemia);
export default __webpack_public_path__ + "static/media/Leukemia.087daac20cab8c3cf505d71615465fdd.svg";
export { ForwardRef as ReactComponent };